
export enum SiteMenuType {
	Unknown = 0,
	FavoritesMenu = -1,
	S1InternalMainNav = 1,
	CustomerWebMainNav = 2,
	CustomerWebMainSecondaryNav = 3
}